export default __webpack_public_path__ + "static/media/pEth.069f428c.png";